/** Legacy grants for retired surfaces; the hard-off registry takes precedence. */
export const PRIVATE_PROPERTY_BETAS = [
  { key: "acquisitions", name: "Acquisitions", href: "/app/acquisitions", apiPrefixes: ["/api/app/acquisitions"] },
  { key: "buy", name: "Buy", href: "/app/buy", apiPrefixes: ["/api/app/buy-deals", "/api/app/wholesaler-listings"] },
  { key: "renovations", name: "Renovate", href: "/app/renovations", apiPrefixes: ["/api/app/renovation-defaults", "/api/app/renovation-settings", "/api/app/renovation-items", "/api/app/properties/:propertyId/renovation-items"] },
  // Launch uses shared property/room APIs; do not block the Properties section.
  { key: "property_launch", name: "Launch", href: "/app/property-launch", apiPrefixes: [] },
  // Marketplace and inquiry APIs are shared with buyers and gated separately.
  { key: "sell", name: "Sell", href: "/app/sell", apiPrefixes: ["/api/app/sell/listings"] },
] as const;

export const FORWARDED_DOCS_BETA = {
  key: "forwarded_docs",
  name: "Forwarded Documents",
  href: "/app/financials/mail-inbox",
} as const;

/** Messages Auto Draft — account-wide AI auto-drafts; admin grants only. */
export const AUTO_DRAFT_BETA = {
  key: "auto_draft",
  name: "Auto Draft",
  href: "/app/messages/auto-draft",
} as const;

/** Private financial and property destinations share navigation and URL guards. */
export function privateBetaForPath(path: string) {
  const pathname = path.split(/[?#]/, 1)[0];
  if (pathname === AUTO_DRAFT_BETA.href || pathname.startsWith(`${AUTO_DRAFT_BETA.href}/`)) {
    return AUTO_DRAFT_BETA;
  }
  if (pathname === FORWARDED_DOCS_BETA.href || pathname.startsWith(`${FORWARDED_DOCS_BETA.href}/`)) {
    return FORWARDED_DOCS_BETA;
  }
  return privatePropertyBetaForPath(path);
}

export function privatePropertyBetaForPath(path: string) {
  const pathname = path.split(/[?#]/, 1)[0];
  return PRIVATE_PROPERTY_BETAS.find(feature =>
    pathname === feature.href || pathname.startsWith(`${feature.href}/`),
  );
}